module.exports = __webpack_public_path__ + "img/icon1.5feb34eb.svg";